import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { FormatService } from '@services/format.service';
import { IndiceModeType } from '@enums/indice-mode-type.enum';

@Component({
    selector: 'app-invest-input',
    templateUrl: './invest-input.component.html',
    styleUrls: ['./invest-input.component.scss']
})
export class InvestInputComponent implements OnInit, OnChanges {
    @Input() value: number;
    @Input() isError: boolean;
    @Input() mode: IndiceModeType = IndiceModeType.amount;
    @Output() valueChanged = new EventEmitter<number>();

    investForm: FormGroup;
    indiceMode = IndiceModeType;

    constructor(
        private fb: FormBuilder,
        private formatSrv: FormatService
    ) { }

    ngOnInit() {
        this.initForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(!changes.value || changes.value.previousValue !== changes.value.currentValue) {
            this.initForm();
        }
    }

    onShowValue(): void {
        this.investForm.controls.amount.setValue(this.value);
    }

    onEmitValue(): void {
        this.value = this.investForm.value.amount;
        this.investForm.controls.amount.setValue(this.convertAmount(this.value));
        this.valueChanged.emit(this.value);
    }

    private initForm(): void {
        this.investForm = this.fb.group({});

        switch(this.mode) {
            case IndiceModeType.percent:
                const indice = this.formatSrv.precision(this.value * 100, 2);
                this.investForm.addControl('indice', this.fb.control(indice, [Validators.required, Validators.min(-100), Validators.max(100)]));
                this.observeIndiceChanges();
                break;
            case IndiceModeType.amount:
            default:
                this.investForm.addControl('amount', this.fb.control(this.convertAmount(this.value), [Validators.required, Validators.min(0)]));
                // this.observeAmountChanges();
        }
    }

    // private observeAmountChanges(): void {
    //     this.investForm.controls.amount.valueChanges
    //     .subscribe((amountS: string) => {
    //         const amount = this.formatSrv.stringToFloat(amountS);
    //         this.valueChanged.emit(amount);
    //     });
    // }

    private observeIndiceChanges(): void {
        this.investForm.controls.indice.valueChanges
        .subscribe((indice: number) => {
            const indiceTemp = this.formatSrv.precision(indice * 0.01, 4);
            this.valueChanged.emit(indiceTemp);
        });
    }

    private convertAmount(value: number): string {
        return this.formatSrv.formatAmount(value, 'rounded', 1, false);
    }

}
